module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_nyy-a198fcd2f4a0cdcd2ef36df9d72f6316.png";